module.exports = __webpack_public_path__ + "img/rebot_2.814edf68.png";